// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__x1OZC","Main":"Game_Main__tAWwN","SideBar":"Game_SideBar__mdCr4"};